import {getCookie, Swal} from '../app.js';

class LearnerAccountView extends HTMLElement {
    constructor() {
        super();
    }

    static get observedAttributes() {
        return ['id', 'json'];
    }

    connectedCallback() {
        var websiteurl = getCookie('WEBSITE_URL');
        const c_websiteurl = websiteurl;
        const c_id = this.id;

        // Sub-tab styles
        var tabStyle = 'display:inline-flex;align-items:center;gap:5px;padding:8px 16px;font-size:12px;font-weight:500;color:#64748b;cursor:pointer;border-bottom:2px solid transparent;transition:all 0.15s;white-space:nowrap;';
        var tabActiveClass = 'stmt-subtab-active';

        this.innerHTML =
            "<style>" +
            "  .stmt-subtabs { display:flex; border-bottom:1px solid #e2e8f0; margin-bottom:0; }" +
            "  .stmt-subtab { " + tabStyle + " }" +
            "  .stmt-subtab:hover { color:#1e293b; }" +
            "  .stmt-subtab." + tabActiveClass + " { color:#2563eb; border-bottom-color:#2563eb; font-weight:600; }" +
            "  .stmt-subpanel { display:none; }" +
            "  .stmt-subpanel.active { display:block; }" +
            "  .stmt-hist-table { width:100%; border-collapse:collapse; font-size:12px; }" +
            "  .stmt-hist-table th { padding:8px 10px; font-size:11px; font-weight:600; color:#64748b; text-transform:uppercase; letter-spacing:.04em; border-bottom:2px solid #e2e8f0; text-align:left; }" +
            "  .stmt-hist-table td { padding:7px 10px; border-bottom:1px solid #f1f5f9; vertical-align:middle; }" +
            "  .stmt-hist-table tr:last-child td { border-bottom:none; }" +
            "  .stmt-history-status { font-size:10px; font-weight:600; padding:2px 8px; border-radius:10px; white-space:nowrap; }" +
            "  .stmt-status-sent { background:#f0fdf4; color:#16a34a; border:1px solid #bbf7d0; }" +
            "  .stmt-status-queued { background:#eff6ff; color:#2563eb; border:1px solid #bfdbfe; }" +
            "  .stmt-history-empty { padding:24px 12px; text-align:center; color:#94a3b8; font-size:12px; }" +
            "</style>" +
            "<div class='stmt-subtabs'>" +
            "  <div class='stmt-subtab " + tabActiveClass + "' data-stmttab='send'>Compose New</div>" +
            "  <div class='stmt-subtab' data-stmttab='history'>History</div>" +
            "</div>" +
            "<div class='stmt-subpanel active' id='stmt-panel-send'>" +
            "  <div id='account-view-container' style='padding:12px 0;'><div style='text-align:center;padding:20px;'><div class='xspinner'></div></div></div>" +
            "</div>" +
            "<div class='stmt-subpanel' id='stmt-panel-history'>" +
            "  <div id='stmt-history-container' style='padding:8px 0;'></div>" +
            "</div>";

        function html_entity_decode(str) {
            var textArea = document.createElement('textarea');
            textArea.innerHTML = str;
            return textArea.value;
        }

        // Sub-tab switching
        $(this).on('click', '.stmt-subtab', function() {
            var tab = $(this).data('stmttab');
            $(this).closest('.stmt-subtabs').find('.stmt-subtab').removeClass(tabActiveClass);
            $(this).addClass(tabActiveClass);
            $(this).closest('learner-account-view').find('.stmt-subpanel').removeClass('active');
            $('#stmt-panel-' + tab).addClass('active');

            // Lazy-load history on first click
            if (tab === 'history' && !$('#stmt-history-container').data('loaded')) {
                loadHistory();
            }
        });

        function loadHistory() {
            var container = $('#stmt-history-container');
            container.html('<div style="text-align:center;padding:20px;"><div class="xspinner"></div></div>');
            container.data('loaded', true);

            $.get(c_websiteurl + 'app.php/learners/statementHistory/' + c_id)
                .done(function(data) {
                    if (!data || data.length === 0) {
                        container.html(
                            '<div class="stmt-history-empty">' +
                            '  <img src="/img/tabler/mail-off.svg" style="height:24px;width:24px;opacity:.3;margin-bottom:6px;display:block;margin:0 auto 6px;">' +
                            '  No statements have been sent yet.' +
                            '</div>'
                        );
                        return;
                    }

                    var html = '<table class="stmt-hist-table">' +
                        '<thead><tr>' +
                        '<th>User</th>' +
                        '<th>Subject</th>' +
                        '<th>Sent to</th>' +
                        '<th>Date</th>' +
                        '<th>Status</th>' +
                        '<th></th>' +
                        '</tr></thead><tbody>';
                    data.forEach(function(row) {
                        var statusClass = row.status === 'Queued' ? 'stmt-status-queued' : 'stmt-status-sent';
                        var ico = row.status === 'Queued' ? 'clock.svg' : 'circle-check.svg';
                        html += '<tr>' +
                            '<td>' + (row.userName || '-') + '</td>' +
                            '<td style="color:#475569;">' + (row.subject || '-') + '</td>' +
                            '<td>' +
                            '<img src="/img/tabler/mail.svg" style="height:13px;width:13px;opacity:.4;vertical-align:-1px;margin-right:4px;">' +
                            row.emailTo +
                            '</td>' +
                            '<td style="white-space:nowrap;">' + row.date +
                            ' <span style="color:#94a3b8;font-size:10px;">(' + row.ago + ')</span></td>' +
                            '<td><span class="stmt-history-status ' + statusClass + '">' +
                            '<img src="/img/tabler/' + ico + '" style="height:10px;width:10px;vertical-align:-1px;margin-right:2px;">' +
                            row.status + '</span></td>' +
                            '<td><button class="btn btn-sm btn-outline-secondary stmt-view-btn" data-id="' + row.id + '" style="font-size:11px;padding:2px 10px;white-space:nowrap;">' +
                            '<img src="/img/tabler/eye.svg" style="height:12px;width:12px;opacity:.6;vertical-align:-1px;margin-right:3px;">View</button></td>' +
                            '</tr>';
                    });
                    html += '</tbody></table>';
                    container.html(html);

                    // View button click — load statement preview in modal
                    container.on('click', '.stmt-view-btn', function() {
                        var mailId = $(this).data('id');
                        Swal.fire({
                            title: 'Statement Preview',
                            html: '<div style="text-align:center;padding:20px;"><div class="xspinner"></div></div>',
                            width: '700px',
                            showConfirmButton: true,
                            confirmButtonText: 'Close Window',
                            customClass: { confirmButton: 'btn btn-sm btn-outline-secondary' },
                            buttonsStyling: false,
                            didOpen: function() {
                                $.get(c_websiteurl + 'app.php/learners/statementPreview/' + mailId)
                                    .done(function(resp) {
                                        var content = resp.html || '<div style="color:#94a3b8;text-align:center;">No content available.</div>';
                                        Swal.update({
                                            html: '<div style="text-align:left;max-height:70vh;overflow-y:auto;font-size:13px;">' + content + '</div>'
                                        });
                                    })
                                    .fail(function() {
                                        Swal.update({
                                            html: '<div style="color:#ef4444;text-align:center;">Failed to load preview.</div>'
                                        });
                                    });
                            }
                        });
                    });
                })
                .fail(function() {
                    container.html('<div class="stmt-history-empty" style="color:#ef4444;">Failed to load history.</div>');
                });
        }

        function loadBlock(data) {
            $("#account-view-container").html(html_entity_decode(data));
        }

        if (c_id > 0) {
            $.get(c_websiteurl + 'app.php/learners/learnerAccountViewRefactored/' + c_id)
                .done(function (data) {
                    loadBlock(data);
                    setTimeout(function() {
                        $('.viewLearnerAccountPlusEmail2').click(function() {
                            $('.viewLearnerAccountPlusEmail2').prop('disabled', true);
                            $('.viewLearnerAccountPlusEmail2').html(
                                '<img src="/img/tabler/loader-2.svg" style="height:14px;width:14px;filter:brightness(0) invert(1);animation:xspin 0.8s linear infinite;">' +
                                ' Sending...'
                            );

                            $.post(c_websiteurl + "app.php/learners/learnerAccountViewRefactored/" + c_id, {sendMail: true}, function(data) {
                                $('.viewLearnerAccountPlusEmail2').html(
                                    '<img src="/img/tabler/check.svg" style="height:14px;width:14px;filter:brightness(0) invert(1);"> Sent'
                                );
                                // Invalidate history cache so it reloads
                                $('#stmt-history-container').data('loaded', false);

                                if (data.success && data.recipients && data.recipients.length > 0) {
                                    var lines = data.recipients.map(function(r) {
                                        var label = r.role;
                                        if (r.name) label += ' — ' + r.name;
                                        return '<div style="padding:3px 0"><img src="/img/tabler/mail.svg" style="height:13px;width:13px;" alt=""> <b>' + label + '</b><br><span style="color:#666">' + r.email + '</span></div>';
                                    }).join('');
                                    Swal.fire({
                                        icon: 'success',
                                        title: 'Statement queued',
                                        html: '<div style="text-align:left;font-size:13px;">' + lines + '</div>',
                                        confirmButtonText: 'OK'
                                    });
                                } else {
                                    Swal.fire({
                                        icon: 'warning',
                                        title: 'No emails sent',
                                        text: 'No valid parent email addresses found for this learner.',
                                        confirmButtonText: 'OK'
                                    });
                                }
                            }, 'json').fail(function() {
                                $('.viewLearnerAccountPlusEmail2').prop('disabled', false).html(
                                    '<img src="/img/tabler/send.svg" style="height:14px;width:14px;filter:brightness(0) invert(1);"> Send Statement'
                                );
                                Swal.fire({icon: 'error', title: 'Error', text: 'Failed to send statement.'});
                            });
                        });
                    }, 1000);
                });
        }
    }
}

window.customElements.define('learner-account-view', LearnerAccountView);
